
import {
  computed,
  defineComponent, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import RequisicaoModal from '@/core/components/Modal/RequisicaoModal.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import {
  IRastreabilidade,
  IRastreabilidadeOrigem,
} from '@/models/Entidades/Estoques/IRastreabilidade';
import Card from '@/core/components/Tela/Card.vue';
import { ETipoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoRastreabilidade';
import SelecionarTipoRastreabilidade from '@/components/Estoques/Rastreabilidade/SelecionarTipoRastreabilidade.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import ServicoRastreabilidade from '@/servicos/Estoques/ServicoRastreabilidade';
import { useGradeBase } from '@/core/composables/GradeBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';
import ServicoVendas from '@/servicos/Vendas/ServicoVendas';
import { IDTOProdutoDefinicao } from '@/models/DTO/Cadastros/Produtos/IDTOProdutoDefinicao';
import SelecionarTipoLancamentoRastreabilidade from '@/components/Estoques/Rastreabilidade/SelecionarTipoLancamentoRastreabilidade.vue';
import { IDTORastreabilidade } from '@/models/DTO/Estoques/Rastreabilidade/IDTORastreabilidade';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IParametroConsultaRastreabilidade } from '@/models/ParametrosRequisicao/Estoques/IParametroConsultaRastreabilidade';
import { INotaFiscalItemEstoque } from '@/models/Entidades/Fiscal/INotaFiscal';

export default defineComponent({
  name: 'SelecaoEstoqueRastreabilidade',
  props: {
    visivel: {
      type: Boolean,
      default: false,
    },
    empresa: {
      type: Number,
      required: true,
    },
    codigoDefinicaoProduto: {
      type: Number,
      default: 0,
    },
    itemEstoque: {
      type: Number,
      default: 0,
    },
    quantidade: {
      type: Number,
      default: 0,
    },
    itemVenda: {
      type: Number,
      default: 0,
    },
    notaFiscalItem: {
      type: Number,
      default: 0,
    },
    tipoLancamento: {
      type: Number,
      default: 1,
    },
    tipoRastreabilidade: {
      type: Number,
      default: ETipoRastreabilidade.Nenhum,
    },
    lancouRastreabilidades: {
      type: Boolean,
      default: false,
    },
    codigoProduto: {
      type: Number,
      default: 0,
    },
    recurso: {
      type: String,
      default: 'PAINEL_VENDAS',
    },
    selecaoUnica: {
      type: Boolean,
      default: false,
    },
    lancamentoInicialMPProducao: {
      type: Boolean,
      default: false,
    },
    rastreabilidadeMPUtilizada: {
      type: Array as () => IRastreabilidade[],
      default: () => [],
    },
    estoqueRastUtilizado: {
      type: Array as () => IDTORastreabilidade[],
      required: true,
    },
    edicao: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RequisicaoModal,
    Icone,
    Card,
    SelecionarTipoRastreabilidade,
    CampoNumerico,
    SelecionarTipoLancamentoRastreabilidade,
    MensagemSemDados,
  },
  emits: ['update:visivel', 'salvar', 'cancelar', 'update:lancouRastreabilidades', 'update:rastreabilidadeMPUtilizada', 'update:quantidade', 'update:estoqueRastUtilizado', 'concluirEdicao'],
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemAlerta, apresentarMensagemErro } = useTelaBase();
    const { modalBase, apresentarBarraProgresso, ocultarBarraProgresso } = useModalBase(props, emit);
    const { gradeBase, carregarPreferenciasGrade } = useGradeBase();
    const servicoRastreabilidade = new ServicoRastreabilidade();
    const servicoProduto = new ServicoProduto();
    const servicoVenda = new ServicoVendas();
    servicoRastreabilidade.requisicaoSistema();
    servicoProduto.requisicaoSistema();

    telaBase.empresasSelecionadas = [];
    gradeBase.ordenacaoSelecionada = [];

    gradeBase.colunasMobile = [
      {
        title: 'Rastreabilidade', dataIndex: '', key: 'Rastreabilidade', position: 0, visible: true, align: 'left',
      },
    ];

    const state = reactive({
      definicaoProduto: {} as IDTOProdutoDefinicao,
      rastreabilidades: [] as IDTORastreabilidade[],
      rastreabilidadesSelecionadas: [] as IRastreabilidade[],
      identificadorSelecionado: '',
      qtdSelecionada: 0,
      qtdTotalSelecionada: 0,
      rastreabilidadeSelecionada: -1,
      buscaRapida: '',
      edicao: false,
      selecaoUnica: false,
    });

    const computedLancouRastreabilidade = computed({
      get: () => props.lancouRastreabilidades,
      set: (valor: boolean) => {
        emit('update:lancouRastreabilidades', valor);
      },
    });
    const computedRastreabilidadeMPUtilizada = computed({
      get: () => props.rastreabilidadeMPUtilizada,
      set: (valor: IRastreabilidade[]) => {
        emit('update:rastreabilidadeMPUtilizada', valor);
      },
    });
    const computedQuantidade = computed({
      get: () => props.quantidade,
      set: (valor: number) => {
        emit('update:quantidade', valor);
      },
    });
    const computedEstoqueRastUtilizado = computed({
      get: () => props.estoqueRastUtilizado,
      set: (valor: IDTORastreabilidade[]) => {
        emit('update:estoqueRastUtilizado', valor);
      },
    });

    function preencherColunas() {
      switch (state.definicaoProduto.tipoRastreabilidade) {
        case ETipoRastreabilidade.Nenhum:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoItemEstoque', key: 'codigoItemEstoque', position: 1, visible: false,
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 2, visible: false, ordering: false, align: 'left', width: 140,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'descricaoEstoque', position: 3, visible: true, ordering: true, align: 'left', width: 250,
            },
            {
              title: 'Qtd Disponível', dataIndex: 'quantidade', key: 'quantidade', position: 4, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 5, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Ações', key: 'acoes', position: 6, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        case ETipoRastreabilidade.Outros:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoEstoque', key: 'codigoEstoque', position: 1, visible: false,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'DescricaoEstoque', position: 2, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 3, visible: true, ordering: true, align: 'left', width: 100,
            },
            {
              title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Qtd Disponível', dataIndex: 'quantidade', key: 'quantidade', position: 5, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 6, visible: true, ordering: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Açoes', key: 'acoes', position: 8, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        case ETipoRastreabilidade.Lote:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoEstoque', key: 'codigoEstoque', position: 1, visible: false,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'DescricaoEstoque', position: 2, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 3, visible: true, ordering: false, align: 'left', width: 140,
            },
            {
              title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true, ordering: false, align: 'left',
            },
            {
              title: 'Qtd Disponível', dataIndex: 'quantidade', key: 'quantidade', position: 5, visible: true, ordering: false, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 6, visible: true, ordering: false, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Nº do Lote', dataIndex: 'numeroLote', key: 'NumeroLote', position: 7, visible: true, ordering: false, align: 'center', width: 100,
            },
            {
              title: 'Validade', dataIndex: 'dataValidade', key: 'DataValidade', position: 8, visible: true, ordering: true, align: 'center', width: 100,
            },
            {
              title: 'Açoes', key: 'acoes', position: 9, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        case ETipoRastreabilidade.Armamento:
          gradeBase.colunasPadrao = [
            {
              title: 'Codigo', dataIndex: 'codigo', key: 'codigo', position: 0, visible: false,
            },
            {
              title: 'Código Estoque', dataIndex: 'codigoEstoque', key: 'codigoEstoque', position: 1, visible: false,
            },
            {
              title: 'Descrição Estoque', dataIndex: 'descricaoEstoque', key: 'DescricaoEstoque', position: 2, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Identificador', dataIndex: 'identificador', key: 'Identificador', position: 3, visible: true, ordering: true, align: 'left', width: 140,
            },
            {
              title: 'Descrição Rastreabilidade', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true, ordering: true, align: 'left',
            },
            {
              title: 'Qtd Rastreabilidades', dataIndex: 'quantidade', key: 'quantidade', position: 5, visible: true, ordering: true, align: 'right', width: 140, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Qtd Selecionada', dataIndex: 'qtdSelecionada', key: 'qtdSelecionada', position: 6, visible: true, ordering: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
            },
            {
              title: 'Nº Arma', dataIndex: 'numeroSerieArma', key: 'NumeroSerieArma', position: 7, visible: true, ordering: true, align: 'center', width: 100,
            },
            {
              title: 'Nº Cano', dataIndex: 'numeroSerieCano', key: 'NumeroSerieCano', position: 8, visible: true, ordering: true, align: 'center', width: 100,
            },
            {
              title: 'Açoes', key: 'acoes', position: 9, visible: true, fixed: 'right', width: 70, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
            },
          ];
          break;
        default:
          gradeBase.colunasPadrao = [];
          break;
      }
    }

    async function limparTela() {
      state.definicaoProduto = {} as IDTOProdutoDefinicao;
      state.rastreabilidades = [] as IDTORastreabilidade[];
      state.rastreabilidadeSelecionada = -1;
      state.identificadorSelecionado = '';
      state.qtdTotalSelecionada = 0;
      state.qtdSelecionada = 0;
      state.buscaRapida = '';
    }

    function filtrar() {
      state.rastreabilidades.forEach((r, i) => {
        if (state.buscaRapida === '') {
          state.rastreabilidades[i].visivel = true;
        } else if (state.buscaRapida.toUpperCase().includes(r.identificador.toUpperCase()) || state.buscaRapida.toUpperCase().includes(r.descricao.toUpperCase()) || state.buscaRapida.toUpperCase().includes(r.numeroLote.toUpperCase()) || state.buscaRapida === UtilitarioData.aplicaFormatoData(r.dataFabricacao)
            || state.buscaRapida === UtilitarioData.aplicaFormatoData(r.dataValidade) || state.buscaRapida.toUpperCase().includes(r.numeroSerieArma.toUpperCase()) || state.buscaRapida.toUpperCase().includes(r.numeroSerieCano.toUpperCase())) {
          state.rastreabilidades[i].visivel = true;
        } else {
          state.rastreabilidades[i].visivel = false;
        }
      });
    }

    function validarCampos() {
      if (state.identificadorSelecionado === '' || state.identificadorSelecionado === undefined) {
        apresentarMensagemAlerta('O identificador deve ser informado!');
        return false;
      }
      const indexRast = state.rastreabilidades.findIndex((r) => r.identificador === state.identificadorSelecionado);
      if (indexRast === -1) {
        apresentarMensagemAlerta('Nenhuma rastreabilidade com o identificador informado!');
        return false;
      }

      if (!state.rastreabilidades[indexRast].estoqueNegativo && state.rastreabilidades[indexRast].quantidade < state.qtdSelecionada) {
        apresentarMensagemAlerta('A quantidade selecionada não pode ser maior que a quantidade disponível da rastreabilidade');
        return false;
      }

      let qtd = state.qtdSelecionada + state.qtdTotalSelecionada;
      if (state.edicao) {
        const qtdAtual = state.rastreabilidades[indexRast].qtdSelecionada;
        if (qtdAtual === state.qtdSelecionada) {
          return true;
        }
        if (qtdAtual < qtd) {
          qtd = state.qtdTotalSelecionada - state.qtdSelecionada;
        }
      }
      if (qtd > props.quantidade && !props.lancamentoInicialMPProducao) {
        apresentarMensagemAlerta('A quantidade adicionada não pode ser maior que a quantidade do item da venda');
        return false;
      }
      if (props.selecaoUnica === true) {
        if (state.rastreabilidades.filter((r) => r.qtdSelecionada > 0).length > 0) {
          if (state.qtdSelecionada > 0 && state.rastreabilidadeSelecionada !== -1) {
            apresentarMensagemAlerta('Só pode haver uma rastreabilidade selecionada.');
            return false;
          }
        }
      }
      return true;
    }

    function adicionar() {
      if (!validarCampos()) return;
      const indexRast = state.rastreabilidades.findIndex((r) => r.identificador === state.identificadorSelecionado);
      if (state.rastreabilidadeSelecionada === -1) {
        state.rastreabilidades[indexRast].qtdSelecionada += state.qtdSelecionada;
      } else {
        state.rastreabilidades[indexRast].qtdSelecionada = state.qtdSelecionada;
      }
      if (props.lancamentoInicialMPProducao) {
        computedQuantidade.value = state.qtdSelecionada;
      }
      if (state.rastreabilidadeSelecionada !== -1) {
        state.rastreabilidades[state.rastreabilidadeSelecionada].qtdSelecionada = state.qtdSelecionada;
      }
      state.qtdSelecionada = 0;
      state.identificadorSelecionado = '';
      state.rastreabilidadeSelecionada = -1;

      state.qtdTotalSelecionada = 0;
      state.rastreabilidades.forEach((r) => {
        state.qtdTotalSelecionada += r.qtdSelecionada;
      });
      state.edicao = false;
    }

    function editar(index: number, edicao: boolean) {
      state.identificadorSelecionado = state.rastreabilidades[index].identificador;
      state.qtdSelecionada = state.rastreabilidades[index].qtdSelecionada;
      state.rastreabilidadeSelecionada = index;
      state.edicao = edicao;
    }

    async function confirmar() {
      if ((props.quantidade - state.qtdTotalSelecionada) !== 0) {
        apresentarMensagemAlerta('A quantidade total das rastreabilidade não é igual a quantidade do produto');
        return;
      }
      if (state.definicaoProduto.tipoRastreabilidade === ETipoRastreabilidade.Nenhum && state.rastreabilidades.length === 0) {
        apresentarMensagemAlerta('Nenhuma rastreabilidade lançada!');
        return;
      }

      if (props.selecaoUnica && state.rastreabilidades.filter((r) => r.qtdSelecionada > 0).length > 1) {
        apresentarMensagemAlerta('Só pode haver uma rastreabilidade selecionada.');
        return;
      }
      if (props.selecaoUnica && state.rastreabilidades.filter((r) => r.qtdSelecionada > 0).length === 0) {
        apresentarMensagemAlerta('Nenhuma rastreabilidade selecionada.');
        return;
      }
      if (props.lancamentoInicialMPProducao && state.rastreabilidades.length === 0) {
        apresentarMensagemAlerta('Nenhuma rastreabilidade lançada!');
        return;
      }
      try {
        state.rastreabilidades.forEach((r) => {
          if (r.qtdSelecionada > 0) {
            const selecao = {} as IRastreabilidade;
            selecao.origem = {} as IRastreabilidadeOrigem;
            selecao.codigo = r.codigo;
            selecao.identificador = r.identificador;
            if (props.lancamentoInicialMPProducao) selecao.codigoItemEstoque = r.codigoItemEstoque;
            selecao.origem.quantidade = r.qtdSelecionada;
            state.rastreabilidadesSelecionadas.push(selecao);
          }
        });
        let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
        if (props.tipoRastreabilidade !== ETipoRastreabilidade.Nenhum) {
          retorno = await servicoRastreabilidade.excluirOrigem(props.itemVenda, props.recurso);
          if (retorno.status !== EStatusRetornoRequisicao.Sucesso) {
            apresentarMensagemAlerta(retorno.mensagem);
            return;
          }
        }
        if (state.rastreabilidades.filter((r) => r.qtdSelecionada > 0).length > 0 && !props.lancamentoInicialMPProducao) {
          if (props.recurso === 'PAINEL_VENDAS') {
            if (props.tipoRastreabilidade === ETipoRastreabilidade.Lote || props.tipoRastreabilidade === ETipoRastreabilidade.Armamento || props.tipoRastreabilidade === ETipoRastreabilidade.Outros) {
              retorno = await servicoRastreabilidade.lancarRastreabilidadeSaida(props.recurso, state.rastreabilidadesSelecionadas);
            }
            const estoques: INotaFiscalItemEstoque[] = Object.values(
              state.rastreabilidades
                .filter((r) => r.qtdSelecionada > 0)
                .reduce((acc, r) => {
                  const key = r.codigoItemEstoque;
                  if (!acc[key]) {
                    acc[key] = {
                      codigo: 0,
                      codigoNotaFiscalItem: props.notaFiscalItem,
                      codigoEmpresa: props.empresa,
                      codigoEstoque: r.codigoEstoque,
                      codigoEstoqueItem: r.codigoItemEstoque,
                      codigoCentroCusto: 0,
                      codigoMovimentoEstoque: 0,
                      quantidade: 0,
                      itemNovo: true,
                    };
                  }
                  acc[key].quantidade += r.qtdSelecionada;
                  return acc;
                }, {} as { [key: string]: INotaFiscalItemEstoque }),
            );
            retorno = await servicoVenda.inserirNotaFiscalItemEstoque(estoques);
            if (retorno.status !== EStatusRetornoRequisicao.Sucesso) {
              apresentarMensagemAlerta(retorno.mensagem);
            }
            computedLancouRastreabilidade.value = true;
            modalBase.computedVisivel = false;
            return;
          }
          computedEstoqueRastUtilizado.value = state.rastreabilidades.filter((r) => r.qtdSelecionada > 0);
          if (props.tipoRastreabilidade === ETipoRastreabilidade.Lote || props.tipoRastreabilidade === ETipoRastreabilidade.Armamento || props.tipoRastreabilidade === ETipoRastreabilidade.Outros) {
            retorno = await servicoRastreabilidade.lancarRastreabilidadeSaida(props.recurso === 'PCP_ORDEM_PRODUCAO' ? 'PCP_ORDEM_PRODUCAO_MP' : props.recurso, state.rastreabilidadesSelecionadas);
            if (retorno.status !== EStatusRetornoRequisicao.Sucesso) {
              apresentarMensagemAlerta(retorno.mensagem);
              return;
            }
          }
          emit('concluirEdicao', state.rastreabilidades.filter((r) => r.qtdSelecionada > 0));
          computedLancouRastreabilidade.value = true;
          modalBase.computedVisivel = false;
          return;
        }
        retorno = await servicoRastreabilidade.excluirOrigem(props.itemVenda, props.recurso);
        if (retorno.status !== EStatusRetornoRequisicao.Sucesso) {
          apresentarMensagemAlerta(retorno.mensagem);
          return;
        }

        if (state.rastreabilidadesSelecionadas.length === 0) {
          apresentarMensagemAlerta('Nenhuma rastreabilidade lançada!');
          return;
        }
        apresentarBarraProgresso();
        if (!props.lancamentoInicialMPProducao) {
          retorno = await servicoRastreabilidade.lancarRastreabilidadeSaida(props.recurso, state.rastreabilidadesSelecionadas);
        } else {
          computedRastreabilidadeMPUtilizada.value = state.rastreabilidadesSelecionadas;
          computedLancouRastreabilidade.value = true;
          modalBase.computedVisivel = false;
          ocultarBarraProgresso();
          return;
        }
        ocultarBarraProgresso();
        if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
          computedLancouRastreabilidade.value = true;
          modalBase.computedVisivel = false;
        } else {
          apresentarMensagemAlerta(retorno.mensagem);
        }
        modalBase.computedVisivel = false;
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
      } finally {
        ocultarBarraProgresso();
      }
    }

    async function obterDadosProduto() {
      state.definicaoProduto = await servicoProduto.obterDadosDetalhesDefinicao(props.codigoDefinicaoProduto);
      preencherColunas();
      carregarPreferenciasGrade(telaBase.preferencias);
      state.selecaoUnica = props.selecaoUnica;
      const parametros = {} as IParametroConsultaRastreabilidade;
      state.rastreabilidadesSelecionadas = [];
      parametros.codigoItemEstoque = 0;
      parametros.codigoMovimento = props.itemVenda;
      parametros.codigoProdutoDefinicao = props.codigoDefinicaoProduto;
      parametros.quantidadeProduto = props.quantidade;
      parametros.tipoLancamento = props.lancamentoInicialMPProducao ? props.tipoLancamento : state.definicaoProduto.tipoLancamentoRastreabilidade;
      parametros.tipoRastreabilidade = state.definicaoProduto.tipoRastreabilidade;
      parametros.empresas = [props.empresa];
      parametros.recurso = props.recurso;
      if (props.edicao) {
        if (props.tipoRastreabilidade === ETipoRastreabilidade.Nenhum) {
          parametros.codigosEdicao = props.estoqueRastUtilizado.map((rast) => rast.codigoMovimento);
        } else {
          parametros.codigosEdicao = props.estoqueRastUtilizado.map((rast) => rast.codigo);
        }
      }
      state.rastreabilidades = await servicoRastreabilidade.obterRastreabilidadesProduto(parametros);
      if (props.edicao) {
        state.rastreabilidades.forEach((rast) => {
          const codigoVinculo = props.tipoRastreabilidade === ETipoRastreabilidade.Nenhum ? rast.codigoItemEstoque : rast.codigo;
          const selecionado = computedEstoqueRastUtilizado.value.find((sel) => sel.codigo === codigoVinculo);
          if (selecionado) {
            // eslint-disable-next-line no-param-reassign
            rast.qtdSelecionada = selecionado.qtdSelecionada;
            // eslint-disable-next-line no-param-reassign
            rast.quantidade += selecionado.qtdSelecionada;
            // eslint-disable-next-line no-param-reassign
            rast.codigoMovimento = selecionado.codigoMovimento;
          }
        });
      } else if (!props.lancamentoInicialMPProducao && props.tipoRastreabilidade === ETipoRastreabilidade.Nenhum) {
        state.rastreabilidades.forEach((rast) => {
          if (props.quantidade > state.qtdTotalSelecionada) {
            // eslint-disable-next-line no-param-reassign
            rast.qtdSelecionada = rast.quantidade < (props.quantidade - state.qtdTotalSelecionada) ? rast.quantidade : props.quantidade - state.qtdTotalSelecionada;
            state.qtdTotalSelecionada += rast.qtdSelecionada;
          }
        });
      }
      state.qtdTotalSelecionada = 0;
      state.rastreabilidades.forEach((r) => {
        state.qtdTotalSelecionada += r.qtdSelecionada;
      });
    }

    function cancelar() {
      emit('cancelar');
      modalBase.computedVisivel = false;
    }

    watch(async () => modalBase.computedVisivel, async () => {
      limparTela();
      if (modalBase.computedVisivel) {
        telaBase.carregando = true;
        await obterDadosProduto();
        telaBase.carregando = false;
      }
    });

    return {
      props,
      state,
      telaBase,
      modalBase,
      gradeBase,
      storeSistema,
      ETipoRastreabilidade,
      ECustomRenderRow,
      UtilitarioGeral,
      UtilitarioMascara,
      UtilitarioData,
      adicionar,
      editar,
      confirmar,
      filtrar,
      cancelar,
    };
  },
});
